export default "__VITE_ASSET__23db8843__"